<template>
  <div class="collection-doorways critical-component-clear">
    <content-carousel
      :cards="blocks"
      :title="content.title"
      :subtitle="content.subtitle"
    />
  </div>
</template>

<script>

/**
 * Vue: Collection doorways (collection-doorways)
 * -----------------------------------------------------------------------------
 * A section to display collection doorway cards.
 * - Component settings: section / dynamic / async / scroll
 *
 * @param {Object} content - Section's text content.
 * @param {String} [content.title]- Title text.
 * @param {String} [content.subtitle]- Subtitle text.
 * @param {Array} blocks - Array of blocks
 */
import ContentCarousel from '~async/content-carousel/content-carousel.vue'

export default {
  name: 'CollectionDoorways',
  components: { ContentCarousel },

  props: {
    content: {
      type: Object,
      default: () => ({
        title: '',
        subtitle: '',
      }),
    },
    blocks: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss">
@import './collection-doorways';
</style>
